'use strict';exports.__esModule = true;var _isEmpty = require('lodash/isEmpty');var _isEmpty2 = _interopRequireDefault(_isEmpty);
var _upperFirst = require('lodash/upperFirst');var _upperFirst2 = _interopRequireDefault(_upperFirst);
var _findMappedLocalization = require('../../cities/findMappedLocalization');
var _commons = require('../commons');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var isFemEnding = function isFemEnding(propType) {return (
    ['apartment', 'garden_apartment', 'rooftop_apartment'].includes(propType));};

var isBasicSearch = function isBasicSearch(params) {return (0, _isEmpty2.default)(params.types);};

var formatBasicSearchTitle = function formatBasicSearchTitle(params, locationSearch, translate, locale) {
  var newProjects = (0, _commons.translateAndLowerCase)(translate, 'SEOSearchTitle', 'newProjects');
  var apartments = (0, _commons.translateAndLowerCase)(translate, 'propertyTypesPlural', 'apartment');
  var rooms = (0, _commons.getRoomsString)(params, translate);
  var baseSentence = '';
  switch (locale) {
    case 'he':{
        var newFem = translate('SEOSearchTitle', 'new', 'fem');
        baseSentence = (0, _upperFirst2.default)(apartments + ' ' + newFem + (!(0, _isEmpty2.default)(rooms) ? ' ' + rooms : '') + ', ' + newProjects);
        break;
      }
    case 'fr':
    case 'en':
      if (!(0, _isEmpty2.default)(rooms)) {
        var _newFem = translate('SEOSearchTitle', 'new', 'fem');
        var homes = translate('SEOSearchTitle', 'homes');
        baseSentence = rooms + ' ' + _newFem + ' ' + homes + ' and ' + apartments;
      } else {
        baseSentence = (0, _upperFirst2.default)(newProjects + ' and ' + apartments);
      }
      break;
    case 'ru':
    default:
      if (!(0, _isEmpty2.default)(rooms) || !(0, _isEmpty2.default)(locationSearch.en)) {
        baseSentence = (0, _upperFirst2.default)('' + newProjects + (!(0, _isEmpty2.default)(rooms) ? ', ' + rooms : ''));
      } else {
        baseSentence = (0, _upperFirst2.default)(newProjects + ' \u0438 ' + apartments);
      }
      break;}

  var mapped = (0, _findMappedLocalization.getMappedLocation)(locationSearch, locale);
  var city = mapped ?
  (0, _findMappedLocalization.formatLocation)(mapped, translate, locale) :
  '';
  if (!(0, _isEmpty2.default)(city)) {
    return baseSentence + ' ' + city;
  }
  return baseSentence;
};

var formatTitleWithPropType = function formatTitleWithPropType(params, locationSearch, translate, locale) {
  var propertyType = params.types[0];
  var rooms = (0, _commons.getRoomsString)(params, translate);
  var mapped = (0, _findMappedLocalization.getMappedLocation)(locationSearch, locale);
  var city = mapped ?
  (0, _findMappedLocalization.formatLocation)(mapped, translate, locale) :
  '';
  var newProjects = translate('SEOSearchTitle', 'newProjects');
  var propType = (0, _commons.translateAndLowerCase)(translate, 'propertyTypesPlural', propertyType);
  var wordNew = isFemEnding(propertyType) ?
  translate('SEOSearchTitle', 'new', 'fem') :
  translate('SEOSearchTitle', 'new', 'masc');
  switch (locale) {
    case 'he':{
        return (0, _upperFirst2.default)(
        propType + ' ' + wordNew + ' ' + (!(0, _isEmpty2.default)(city) ? city : '') + (!(0, _isEmpty2.default)(rooms) ? ' ' + rooms : '') + ', ' + newProjects);
      }
    case 'fr':
    case 'en':{
        return (0, _upperFirst2.default)('' + (
        !(0, _isEmpty2.default)(rooms) ? ' ' + rooms + ' ' : '') + wordNew + ' ' + propType + ' ' + (!(0, _isEmpty2.default)(city) ? city : ''));
      }
    case 'ru':
    default:
      return (0, _upperFirst2.default)(
      wordNew + ' ' + propType + (!(0, _isEmpty2.default)(rooms) ? ', ' + rooms : '') + (!(0, _isEmpty2.default)(city) ? ' ' + city : ''));}

};

var formatProjectsTitle = function formatProjectsTitle(routeData, translate) {var

  locale =


  routeData.locale,_routeData$params = routeData.params,params = _routeData$params === undefined ? {} : _routeData$params,_routeData$locationSe = routeData.locationSearch,locationSearch = _routeData$locationSe === undefined ? {} : _routeData$locationSe;
  if (isBasicSearch(params, locationSearch)) {
    return formatBasicSearchTitle(params, locationSearch, translate, locale);
  }
  return formatTitleWithPropType(params, locationSearch, translate, locale);
};exports.default =

formatProjectsTitle;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/seo/projects/title.js
// module id = 3144
// module chunks = 0